import { clsx } from 'clsx';
import * as React from 'react';

import * as styles from './sendMessageButton.css';

interface ISendMessageButtonProps {
  // TODO: Удалить проп builderButton в CD-235461.
  builderButton?: boolean;
  noMarginTop?: boolean;
}

export const SendMessageButton = (props: React.PropsWithChildren<ISendMessageButtonProps>) => {
  const { builderButton, noMarginTop, children } = props;

  return (
    <div
      className={clsx(styles['button'], {
        [styles['button--builder']]: builderButton,
        [styles['no-margin-top']]: noMarginTop,
      })}
    >
      {children}
    </div>
  );
};
